import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { Image } from '../../Image';
import { ParagraphWrapper } from '../ParagraphWrapper';
import { t } from '../../../domain/services/configService';
import { theme } from '../../../domain/theme';
import { HorizontalScrollContainer } from '../../responsive/organisms/HorizontalScrollContainer';

const ImageThumbnailMenuInner = ({
  images,
  selectedImage,
  backgroundColor = 'white',
  onClickCb,
  isAboveTheFold = false
}) => {
  const styles = {
    thumbnails: css`
      display: inline-flex;
      gap: 20px;
      margin-bottom: 16px;
      .selected {
        opacity: 1;
        border: 4px solid #ffcc00;
      }
    `,
    thumbnail: css`
      border: 4px solid #0000;
      box-sizing: initial;
      width: 72px;
      height: 40px;
      ${theme.mq.tablet} {
        width: 93px;
        height: 53px;
      }
    `,
    button: css`
      -webkit-appearance: none;
      border: none;
      background-color: ${backgroundColor};
    `
  };

  const thumbsContainer = useRef();
  useEffect(() => {
    const activeThumb = thumbsContainer.current.querySelector('.selected');
    const thumbScrollContainer =
      thumbsContainer.current.querySelector('.scroll-container');
    if (activeThumb) {
      const thumbScrollContainerWidth = thumbScrollContainer.offsetWidth;
      const thumbWidth = activeThumb.offsetWidth;
      const thumbLeft = activeThumb.offsetLeft;
      const scrollPosition =
        thumbLeft - thumbScrollContainerWidth / 2 + thumbWidth / 2;
      thumbScrollContainer.scroll({
        left: scrollPosition,
        behavior: 'smooth'
      });
    }
  }, [selectedImage]);

  return (
    <HorizontalScrollContainer
      backgroundColor={backgroundColor}
      hideArrows
      gradient={{ prev: ['0%', '100%'], next: ['0%', '100%'] }}
      align="center"
      width="90vw"
      maxWidth="1080px"
      margin="0 auto"
      ref={thumbsContainer}
    >
      <ul css={styles.thumbnails}>
        {images.map((image, index) => {
          return (
            <li
              css={[styles.thumbnail]}
              className={index === selectedImage ? 'selected' : undefined}
              key={image.entity.id}
            >
              <button
                css={styles.button}
                type="button"
                onClick={() => onClickCb(index)}
                label={t('__VIEW__')}
              >
                <Image
                  entity={image.entity}
                  maxWidths={{
                    mobile: 78,
                    tablet: 101,
                    small_desktop: 101,
                    large_desktop: 101
                  }}
                  aspect="16x9"
                  loading={isAboveTheFold ? 'eager' : 'lazy'}
                  fade={false}
                />
              </button>
            </li>
          );
        })}
      </ul>
    </HorizontalScrollContainer>
  );
};

ImageThumbnailMenuInner.propTypes = {
  images: PropTypes.arrayOf(PropTypes.any).isRequired,
  selectedImage: PropTypes.number.isRequired,
  onClickCb: PropTypes.func.isRequired,
  backgroundColor: PropTypes.string,
  isAboveTheFold: PropTypes.bool
};

export const ImageThumbnailMenu = ParagraphWrapper(ImageThumbnailMenuInner);
